module.exports = __webpack_public_path__ + "18d4a6ca83c6c7e03daf9f2834fa4d92.svg";